export default "__VITE_ASSET__BsgH6vya__"